import {
    Component,
    Output,
    EventEmitter,
    Input
} from "@angular/core";
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { ElencoFiltriService } from "../ElencoFiltri.service";
import { Filtro } from "../filtri.type";
import { SuperCampo } from "../model/superCampo";


export class DataCampoFiltro {
    campo: any = "";
}

@Component({
    selector: "lista-filtri-compilabili",
    templateUrl: "./lista-filtri-compilabili.html"
})
export class ListaFiltriCompilabiliComponent {
    private _elencoFiltriService: ElencoFiltriService

    @Input('elencoFiltriService')
    set elencoFiltriService(value: ElencoFiltriService) {
        this._elencoFiltriService = value;
        this.initElencoFiltri();
    }

    get elencoFiltriService() {
        return this._elencoFiltriService
    }

    elencoSub: Subscription;

    @Output()
    nuovoFiltro = new EventEmitter<any>();
    @Output()
    chiudiPopUp = new EventEmitter<boolean>();

    listaFiltriCompilabili: SuperCampo[] = [];

    constructor() { }

    initElencoFiltri() {
        if (!this.elencoSub) {
            //al primo init mi prendo i filtri correnti
            const elencoFiltriSnapshot=this.elencoFiltriService.getListaFiltriSnapshot();
            this.initFiltriCompilabili(elencoFiltriSnapshot);
            this.elencoSub = this.elencoFiltriService.getListaFiltriAsObservable().subscribe(
                (res: Filtro[]) => {
                    this.initFiltriCompilabili(res);
                }
            )
        }
    }

    initFiltriCompilabili(filtri: Filtro[]) {
        this.listaFiltriCompilabili = [];
        let filtriVisualizzabili: Filtro[] = filtri.filter(el => {
            if (el.configFiltro) {
                if (el.visibile !== undefined) {
                    return el.visibile;//solamente quelli visualizzabili eheh
                }
                return false;
            }
            return false;
        });
        //ottengo SuperCampo per i filtri standard
        for (let filtro of filtriVisualizzabili) {
            let filtroCompilabile: SuperCampo;
            if (filtro.configFiltro.controlType !== "selezione-multipla") {
                filtroCompilabile = new SuperCampo({
                    id: filtro.idFiltro,
                    key: filtro.nomeCampo,
                    label: filtro.label,
                    order: 2,
                    controlType: filtro.configFiltro.controlType,
                    options: filtro.configFiltro.options,
                    type: filtro.configFiltro.type,
                    pattern: filtro.configFiltro.pattern,
                    value: filtro.formValue ? filtro.formValue : filtro.valore,
                    maxlength: filtro.configFiltro.maxlength,
                    operator: {
                        id: filtro.operatoreId,
                        text: filtro.labelOperatore
                    },
                    extra: {
                        suggerimenti: filtro.configFiltro.suggerimenti
                    }
                });
                this.listaFiltriCompilabili.push(filtroCompilabile);
            }
        }

        //ottengo SuperCampo per i filtri "selezione-multipla" 
        let filtriMultipli: Filtro[] | any[] = [...filtriVisualizzabili].filter(el => {
            return el.configFiltro.controlType == "selezione-multipla";//solamente quelli visualizzabili eheh
        }).map((el: any) => {
            el.groupField = el.nomeCampo + "" + el.operatoreId + "" + el.idConfig;
            return el;
        });
        // console.log("filtriMultipli", filtriMultipli);
        const gruppoMultipli = _.groupBy(filtriMultipli, o => o.groupField);
        if (Object.keys(gruppoMultipli).length > 0)
            for (let index in gruppoMultipli) {
                const filtri = gruppoMultipli[index];
                const filtro: Filtro = filtri[0];
                let filtroCompilabile = new SuperCampo({
                    id: filtro.idFiltro,
                    key: filtro.nomeCampo,
                    label: filtro.label,
                    order: 2,
                    controlType: filtro.configFiltro.controlType,
                    options: filtro.configFiltro.options,
                    type: filtro.configFiltro.type,
                    pattern: filtro.configFiltro.pattern,
                    value: filtro.valore,
                    maxlength: filtro.configFiltro.maxlength,
                    operator: {
                        id: filtro.operatoreId,
                        text: filtro.labelOperatore
                    },
                    extra: {
                        filtriMapped: filtri.map((el: Filtro) => {
                            return {
                                idFiltro: el.idFiltro,
                                idOption: el.valore,
                                isChecked: el.isAttivo
                            }
                        }),//array di id filtri
                    }
                });
                this.listaFiltriCompilabili.push(filtroCompilabile);
            }
        // console.log("listaFiltriCompilabili", this.listaFiltriCompilabili);
    }

    setFiltro(event: { id: string, value: any, forceDisattivazione: boolean }) {
        if (event.id) {
            if (!event.forceDisattivazione && event.value !== undefined) {
                this.elencoFiltriService.setValoreFiltrobyId(event.id, event.value);
            } else {
                this.elencoFiltriService.cambiaStatoFiltrobyId(event.id, false, event.value);
            }
        }
    }

    chiudiModale(chiudi: boolean) {
        this.chiudiPopUp.emit(chiudi);
    }
}
